"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var client_1 = __importDefault(require("./client"));
var mapBetterAuthSession = require('./mapBetterAuthSession');
var useCarolineSession = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.revalidate, revalidate = _c === void 0 ? false : _c;
    var authState = client_1.default.useSession();
    var _d = (0, react_1.useState)(!revalidate), hasRevalidated = _d[0], setHasRevalidated = _d[1];
    var _e = (0, react_1.useState)(false), revalidationFailed = _e[0], setRevalidationFailed = _e[1];
    var initialRequestPending = (0, react_1.useRef)(authState.isPending);
    var revalidationStarted = (0, react_1.useRef)(false);
    var refetch = (0, react_1.useRef)(authState.refetch);
    refetch.current = authState.refetch;
    (0, react_1.useEffect)(function () {
        if (!revalidate) {
            setHasRevalidated(true);
            return;
        }
        // Better Auth already fetches once on the first mount. Wait for that
        // response instead of issuing a duplicate request; cached sessions
        // are explicitly revalidated when this gate mounts later.
        if (initialRequestPending.current) {
            if (authState.isPending)
                return;
            initialRequestPending.current = false;
            setHasRevalidated(true);
            return;
        }
        // isPending changes when refetch starts and finishes. Only start one
        // explicit revalidation for this gate mount, otherwise those changes
        // would create an unbounded request loop.
        if (revalidationStarted.current)
            return;
        revalidationStarted.current = true;
        setHasRevalidated(false);
        setRevalidationFailed(false);
        Promise.resolve()
            .then(function () { return refetch.current(); })
            .then(function () { return setHasRevalidated(true); }, function () {
            setRevalidationFailed(true);
            setHasRevalidated(true);
        });
    }, [revalidate, authState.isPending]);
    if (revalidate && !hasRevalidated) {
        return { user: null, isAuthenticated: false, status: 'loading' };
    }
    if (revalidate && revalidationFailed) {
        return { user: null, isAuthenticated: false, status: 'unavailable' };
    }
    return mapBetterAuthSession(authState);
};
exports.default = useCarolineSession;
